import { render, staticRenderFns } from "./accountset.vue?vue&type=template&id=18ab7b5a&scoped=true"
import script from "./accountset.vue?vue&type=script&lang=js"
export * from "./accountset.vue?vue&type=script&lang=js"
import style0 from "./accountset.vue?vue&type=style&index=0&id=18ab7b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ab7b5a",
  null
  
)

export default component.exports